// Imports
import React, { useState } from 'react';
import availableSubscriptionSizes from '../../../shareables/utils/billing/available-subscription-sizes';
import Comparison from './comparison';
import Plans from './plans';
import Toggle from './toggle';
import QuestionsAndAnswers from './questions-and-answers';
import SimplePageTemplate from '../../resources/simple-page-template';
import planMapping from '../../../shareables/utils/billing/plan-mapping';
import HouseholdSlider from './household-slider';


// Types
export type View = 'MONTHLY' | 'YEARLY';


// Define the accepted props
interface Props {
	storybookView?: View;
}


// Function component
const Pricing: React.FC<Props> = ({ storybookView }) => {
	// Use state
	const [view, setView] = useState<View>(storybookView ?? 'YEARLY');
	const [sizeIndex, setSizeIndex] = useState(0);
	
	
	// Return JSX
	return (
		<SimplePageTemplate
			heading='Unrivaled value for every community'
			descriptor='Try HOA Express risk-free for 30 days—no credit card needed'
		>
			<HouseholdSlider sizeIndex={sizeIndex} setSizeIndex={setSizeIndex} />
			
			<Toggle view={view} setView={setView} />
			
			<Plans view={view} sizeIndex={sizeIndex} setSizeIndex={setSizeIndex} />
			
			<Comparison size={availableSubscriptionSizes(planMapping.engage)[sizeIndex]} />
			
			<QuestionsAndAnswers />
		</SimplePageTemplate>
	);
};

export default Pricing;
